export default "/clashmini.3f003cb8-4092ad.webp";